module.exports = __webpack_public_path__ + "908e4d2e/img/settings-icon.121d9519.svg";